import script from "./TopUpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TopUpModal.vue?vue&type=script&setup=true&lang=js"

import "./TopUpModal.vue?vue&type=style&index=0&id=348275d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348275d6"]])

export default __exports__